module.exports = __webpack_public_path__ + "static/media/01A.c1508eb0.png";